import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import UserIcon from "../../../assets/user-image-plc/User_Cat.svg";
import DaniIcon from "../../../assets/dani_icon.svg";
import { marked } from "marked";
import parse from "html-react-parser";
import { Button } from "reactstrap";
import withLoading from "../../../hoc/Loading/Loading";
import { toastContainer } from "../../../utils/toast";
import moment from "moment";
import sortBy from "lodash.sortby";
import { getMessageTime } from "../../../utils/constants";
import ReactPlayer from "react-player";
import YouTubeEmbed from "../YoutubeEmbed";
import { deepClone } from "../../../utils/copyObject";
import { findLast } from "lodash";
import { BiChevronRight } from "react-icons/bi";

function UserSMSChats(props) {
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    const phoneNumber = decodeURIComponent(props.match.params.phoneNumber);
    axios
      .post(url.getAllConversationsByNumber, { phoneNumber: `+${phoneNumber}` })
      .then(({ data }) => {
        setConversations(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const formatMessage = (chatList) => {
    const item = chatList[chatList.length - 1];

    const text = item
      ? item.response
        ? item.response
        : item.message
        ? item.message
        : item.videos
        ? item.videos[0]
        : item.hasImage
        ? item.imageUrl
        : "No message"
      : "No message";

    if (text.length > 200) {
      return `${text.slice(0, 198)}...`;
    } else {
      return text;
    }
  };

  const handleChatPageRedirect = (conversation) => {
    props.history.push(conversation._id);
  };

  return (
    <div className="">
      <div className="">
        {conversations.map((item) => {
          return (
            <div
              key={item._id}
              className="desktop-chatlist-main cursor-pointer"
              onClick={() => {
                handleChatPageRedirect(item);
              }}
            >
              <div className="chatlist-message-content">
                <div>{formatMessage(item.conversations)}</div>
                <div className="d-block">
                  <span className="chatlist-chattime-text ml-auto" style={{position:"relative",left:"80%"}}>
                    {" "}
                    {getMessageTime(item.messageDate)}
                    <BiChevronRight size={"20px"} />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default withRouter(withLoading(UserSMSChats, axios));
